<template>
    <div class="form-overlay identify-content" :class="position">
        <div class="steep1" v-if="steep == 1">
            <p >Cliquer sur l'image ou sur la video<br>pour selectionner une personne</p>
            <div class="content" v-if="personsSelect.length">
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="false"></span>
                    <div class="item" v-for="person in personsSelect" :key="person.id || person.name">
                        <img :src="person.image ? person.image : 'img/avatar.jpg'" alt="">
                        <div class="info">
                            <p class="username">{{ person.id ? person.id : person.name }}</p>
                            <p class="name">{{ person.name }}</p>
                        </div>
                        <i class="fa-regular fa-xmark" @click="removePerson(person.id)"></i>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="steep2" v-else-if="steep == 2">
            <div class="content">
                <div class="input">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input placeholder="Rechercher une personne" v-model="textSearch" v-on:keyup.enter="sendSearchPerson">
                </div>

                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <div class="item" v-else v-for="person in listPersonsAvailable" @click="selectPerson(person)" :key="person.id || person.name">
                        <img :src="person.image ? person.image : 'img/avatar.jpg'" alt="">
                        <div class="info">
                            <p class="username">{{ person.id ? person.id : person.name }}</p>
                            <p class="name">{{ person.name }}</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="btn-secondary" @click="$emit('close')">Fermer</div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    export default {
        props: {
            positionClick: {
                type: Object,
                default: undefined
            },
            personsSelect: {
                type: Array,
                default: ()=>[] 
            },
            position: {
                type: String,
                default: 'left'
            },
        },

        data() {
            return {
                steep : 1,
                textSearch : '',
                lastIdEvent : 0,
                stateLoader : false,
                listPersonsAvailable : [],
                timeoutInitSearch : null,
            }
        },

        mounted() {
            EventBus.$on('resultSearchFromSelectPerson', this.receveidPerson);
        },

        methods: {
            sendSearchPerson() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchFromSelectPerson",this.textSearch,this.lastIdEvent)
            },

            receveidPerson(persons,idEvent) {
                if ( this.lastIdEvent == idEvent) {
                    this.listPersonsAvailable = persons
                    this.stateLoader = false
                }
            },

            selectPerson(person) {
                EventBus.$emit("eventClickSelectPerson",{
                    ...person,
                    ...this.positionClick,
                    timestamp : Date.now()
                })
                this.$emit("resetPositionClick")
            },

            removePerson(idPerson) {
                EventBus.$emit("eventRemoveSelectPerson",idPerson)
            }
        },

        watch: {
            textSearch(newValue, oldValue) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchPerson()
                },1000)
            },

            positionClick(newValue, oldValue) {
                if (newValue) {
                    this.steep = 2
                }else{
                    this.steep = 1
                }
              
            }
        },

        beforeDestroy () {
            EventBus.$off('resultSearchFromSelectPerson', this.receveidPerson);
        }
    }
</script>
    